import axios from 'axios';
import router from '../router';
import { useUserInfoStore } from '@/stores/userInfo'
import { globalStore } from '../stores/global'
import { ElMessage } from 'element-plus'
const $http = axios.create({
    //设置默认请求地址
    baseURL: import.meta.env.VITE_BASE_URL,
    //设置请求超时时间
    timeout: 60000,
    //设置请求头
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
})
// 先导入vuex,因为我们要使用到里面的状态对象

let userInfo:any = null;

let global:any = null;

// 请求拦截器
$http.interceptors.request.use((config: any) => {
    // 每次发送请求之前判断vuex中是否存在token
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    const token = userInfo.token;
    token && (config.headers.Authorization = 'Bearer ' + token);
    return config;
}, error => {
    return Promise.reject(error.data.error.message);
})

//响应拦截
$http.interceptors.response.use(res => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    if (res.status === 200) {
        if(res.data.status.code == 401001
            || res.data.status.code == 401002
            || res.data.status.code == 401004
            || res.data.status.code == 401005
            || res.data.status.code == 401006
            || res.data.status.code == 401008
            || res.data.status.code == 401009
        ){
            global.setLoadingValue(false)
            // 清除token
            userInfo.setToken('');
            // 跳转登录页面，并将要浏览的页面Path传过去，登录成功后跳转需要访问的页面
            setTimeout(() => {
                router.replace({
                    path: '/login',
                    query: {
                        redirect: router.currentRoute.value.path
                    }
                });
            }, 1000);
        }
        return Promise.resolve(res.data);
    } else {
        global.setLoadingValue(false)
        return Promise.reject(res.data);
    }
}, error => {
    global.setLoadingValue(false)
    if (error.response.status) {
        switch (error.response.status) {
            // 401: 未登录
            // 未登录则跳转登录页面，并携带当前页面的路径
            // 在登录成功后返回当前页面，这一步需要在登录页操作。
            case 401:
                userInfo.setToken('');
                router.replace({
                    path: '/login'
                });
                break;
            // 403 token过期
            // 登录过期对用户进行提示
            // 清除本地token和清空vuex中token对象
            // 跳转登录页面
            case 403:
                // 登录过期，请重新登录
                ElMessage.error('登陆过期，请重新登陆')
                // 清除token
                userInfo.setToken('');
                // 跳转登录页面，并将要浏览的页面Path传过去，登录成功后跳转需要访问的页面
                setTimeout(() => {
                    router.replace({
                        path: '/login',
                        query: {
                            redirect: router.currentRoute.value.path
                        }
                    });
                }, 1000);
                break;
            // 404请求不存在
            case 404:
                // 网络请求不存在'
                ElMessage.error('网络异常，请稍后再试')
                break;
        }
        return Promise.reject(error.res);
    }else{
        ElMessage.error('网络异常，请稍后再试')
    }
})

export function http(){
    userInfo = useUserInfoStore()
    global = globalStore()

    return $http
}
